import React from "react";
import getVariantColor from "helpers/get-variant-color";

export const VariantSelectorCircles = ({ colors, selected, onVariantChange, variantColors }) => (
    <div className="w-full pb-2.5">
        <ul className="flex justify-center list-none">
            {colors.map((color) => {
                const colorTitle = color.replace(/[/\s]/g, "-").toLowerCase();
                const selectedColor = selected.replace(/[/\s]/g, "-").toLowerCase();
                if (!colorTitle) return null;

                return (
                    <li key={colorTitle} className="select-none mx-1">
                        <button
                            type="button"
                            className={`swatch ${colorTitle === selectedColor && "swatch-active"}`}
                            onClick={() => onVariantChange(color)}
                            style={{ backgroundColor: getVariantColor(variantColors, colorTitle) }}
                            aria-label={`Variant Color: ${colorTitle}`}
                        />
                    </li>
                );
            })}
        </ul>
    </div>
);

export const VariantSelectorBoxes = ({ colors, selected, onVariantChange, variantColors }) => (
    <div className="flex flex-col pb-4">
        <div className="flex flex-col mb-3">
            <p className="md:text-sm">
                <strong>COLOR: </strong>
                {selected}
            </p>
        </div>
        <div className="flex gap-2.5 flex-wrap">
            {colors.map((color) => {
                // Replaces whitespace or slashes with a hyphen (-)
                const colorTitle = color.replace(/[/\s]/g, "-").toLowerCase();
                const selectedColor = selected.replace(/[/\s]/g, "-").toLowerCase();
                if (!colorTitle) return null;

                return (
                    <div
                        key={colorTitle}
                        className={`flex w-fit p-0.5 border border-[#e1e1e1] ${colorTitle === selectedColor && "shadow-variantBoxShadow border-transparent"}`}
                        style={{ backgroundColor: getVariantColor(variantColors, colorTitle) }}
                    >
                        <button
                            type="button"
                            aria-label={`Variant Color: ${colorTitle}`}
                            style={{ backgroundColor: getVariantColor(variantColors, colorTitle) }}
                            className={`w-14 h-5 ${colorTitle === selectedColor && "border shadow-sm"}`}
                            onClick={() => onVariantChange(color)}
                        />
                    </div>
                );
            })}
        </div>
    </div>
);
